import { render } from "./messageview.vue?vue&type=template&id=62f1dbf0&scoped=true"
import script from "./messageview.vue?vue&type=script&lang=js"
export * from "./messageview.vue?vue&type=script&lang=js"

import "./messageview.vue?vue&type=style&index=0&id=62f1dbf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62f1dbf0"

export default script